import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class extends Controller {
  static targets = ["stopButton"];

  connect() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    this.swiper = new Swiper(".js-top-event-slider", {
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      lazy: true,
      loop: true,
      spaceBetween: 24,
      speed: 300,
      slidesPerView: "auto",
      centeredSlides: true,
      breakpoints: {
        768: {
          spaceBetween: 8,
        },
      },
      pagination: {
        el: ".js-top-event-slider-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-top-event-slider-next",
        prevEl: ".js-top-event-slider-prev",
      },
      keyboard: {
        enabled: true,
      },
    });
  }

  // 再生/停止ボタン
  sliderstop(e) {
    if ($(e.currentTarget).hasClass("is-pause")) {
      this.swiper.autoplay.start();
      $(e.currentTarget).removeClass("is-pause");
      $(e.currentTarget).text("停止する");
    } else {
      this.swiper.autoplay.stop();
      $(e.currentTarget).addClass("is-pause");
      $(e.currentTarget).text("再生する");
    }
  }
}
